import {memo, ShapeComponent, shapeComponent} from "shared/base"
import React, {useMemo} from "react"
import RenderHtml, {defaultSystemFonts} from "react-native-render-html"
import {StyleSheet} from "react-native"
import {useDefaultStyle} from "@kaspernj/api-maker/build/utils/default-style"

const systemFonts = [...defaultSystemFonts, "DreamChaser", "HankenGrotesk", "Nunito"]

/**
 * @typedef {object} SharedRenderHtmlProps
 * @property {unknown} source
 */

/** @typedef {object} SharedRenderHtmlState */

/**
 * @extends {ShapeComponent<SharedRenderHtmlProps, SharedRenderHtmlState>}
 */
class SharedRenderHtml extends ShapeComponent {
  render() {
    const {source, ...restProps} = this.props
    const defaultStyle = useDefaultStyle()

    const defaultTextStyle = useMemo(() => {
      if (defaultStyle?.Text) {
        const originalTextStyle = StyleSheet.flatten(defaultStyle.Text)
        const newTextStyle = {}

        for (const key in originalTextStyle) {
          const value = originalTextStyle[key]

          if (value === undefined) {
            continue
          }

          newTextStyle[key] = value
        }

        return newTextStyle
      }
    }, [defaultStyle.Text])

    const sourceProps = useMemo(
      () => ({html: source}),
      [source]
    )

    const tagsStyles = useMemo(() => {
      const tagsStyles = {
        body: Object.assign(
          {fontFamily: defaultTextStyle?.fontFamily || "HankenGrotesk"},
          defaultTextStyle
        )
      }

      return tagsStyles
    }, [defaultTextStyle])

    return (
      <RenderHtml
        allowFontScaling
        source={sourceProps}
        systemFonts={systemFonts}
        tagsStyles={tagsStyles}
        {...restProps}
      />
    )
  }
}

export default memo(shapeComponent(SharedRenderHtml))
